var _defs, _path, _g, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_503",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 503",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64.026,
    height: 63.211,
    viewBox: "0 0 64.026 63.211",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_853",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 853",
    d: "M6.413-4.341H51.231a6.4,6.4,0,0,1,6.4,6.4L54.943,48.211a6.4,6.4,0,0,1-6.4,6.4H10.43a6.4,6.4,0,0,1-6.4-6.4L.01,2.062A6.4,6.4,0,0,1,6.413-4.341Z",
    transform: "translate(-0.01 4.341)",
    fill: "#7e92a3"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_852",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 852",
    d: "M6.413-4.341H51.231a6.4,6.4,0,0,1,6.4,6.4L54.943,48.211a6.4,6.4,0,0,1-6.4,6.4H10.43a6.4,6.4,0,0,1-6.4-6.4L.01,2.062A6.4,6.4,0,0,1,6.413-4.341Z",
    transform: "translate(3.207 8.598)",
    fill: "#b4bdc4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0413\\u0440\\u0443\\u043F\\u043F\\u0430_\\u043C\\u0430\\u0441\\u043E\\u043A_8",
    "data-name": "\\u0413\\u0440\\u0443\\u043F\\u043F\\u0430 \\u043C\\u0430\\u0441\\u043E\\u043A 8",
    transform: "translate(3.218 4.257)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A_111",
    "data-name": "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A 111",
    width: 64.026,
    height: 12.805,
    rx: 3,
    transform: "matrix(0.978, -0.208, 0.208, 0.978, -4.482, 9.055)",
    fill: "#969ea3"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A_112",
    "data-name": "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A 112",
    width: 64.026,
    height: 12.005,
    rx: 3,
    transform: "translate(0)",
    fill: "#b4bdc4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.57165d61728ef49b297c0331f38cd007.svg";
export { ForwardRef as ReactComponent };